export default __webpack_public_path__ + "static/media/4-card.0495d7c2.png";